export default __webpack_public_path__ + "static/media/mr.080aa60e.svg";